module.exports = __webpack_public_path__ + "media/honey-icons/icon-user-391c875c.svg";